import { Component, OnInit, Input, SimpleChange, SimpleChanges, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Rilevazione } from 'src/app/models/rilevazione-presenze/rilevazione';
import { UtilityService } from 'src/app/services/utility.service';
import { format } from 'date-fns';
import itLocale from 'date-fns/locale/it';
import { ConfigService } from 'src/app/services/config-service/config-service';


@Component({
    selector: 'app-info-rilevazione',
    templateUrl: './info-rilevazione.component.html',
    styleUrls: ['./info-rilevazione.component.scss'],
    standalone: false
})
export class InfoRilevazioneComponent implements OnInit, OnChanges {
  @Input() rilevazione: Rilevazione;
  @Input() viewinelenco = false;
  @Input() viewinraccolta = false;
  @Input() viewinstorico = false;
  @Input() viewinrichiestegiustifica = false;
  

  dateOpts: any;
  timeFormatted: any;
  dayFormatted: any;
  dateFormatted: any;

  constructor(
    private utilityService: UtilityService,
    private translateService: TranslateService,
    public configService: ConfigService

  ) {}

  ngOnInit() {
    console.log('rilevazione', this.rilevazione);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['rilevazione']) {
      if (this.translateService.currentLang === 'it') {
        this.dateOpts = { locale: itLocale };
      }

      this.timeFormatted = format(new Date(this.rilevazione.istanteCreazione), 'H:mm', this.dateOpts );
      this.dayFormatted = format(new Date(this.rilevazione.istanteCreazione), 'EEE', this.dateOpts );
      this.dateFormatted = format(new Date(this.rilevazione.istanteCreazione), 'd MMMM y', this.dateOpts );
    }
}

  showHint(mess, mess2: string = null, event = null) {
    this.utilityService.showHintNoProp(mess, mess2, event);
  }

}
